import React from 'react';

import { localDate } from 'Components/budget_change_requests/changeRequestFormat';

import Badge from 'CommonComponents/Badge';

/**
 * Whose turn it is, what the record is and where it came from, and who raised it.
 * The requisition links out only when the server sent a URL — it withholds one
 * from an approver who could not open it.
 */
export default function CommitmentStatusLine({ detail, pending }) {
    const requisition = detail.purchase_requisition;

    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-1 tw-text-[13px] tw-text-charcoal-75">
            {pending && (
                <Badge variant="warning" size="md">
                    {$t('Pending your approval')}
                </Badge>
            )}
            <span>
                {detail.kind === 'ea' ? $t('Expenditure approval') : $t('Direct commitment')}{' '}
                <span className="tw-font-semibold tw-text-charcoal">{detail.reference}</span>
                {requisition && (
                    <>
                        {' · '}
                        {$t('raised from')}{' '}
                        {requisition.url ? (
                            <a href={requisition.url} target="_blank" rel="noopener noreferrer" className="tw-font-semibold tw-text-blue">
                                {requisition.reference}
                            </a>
                        ) : (
                            <span className="tw-font-semibold tw-text-charcoal">{requisition.reference}</span>
                        )}
                    </>
                )}
            </span>
            <span>{$t('Requested by {{name}}, {{date}}', { name: detail.requested_by, date: localDate(detail.submitted_at) })}</span>
        </div>
    );
}
